// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"b426528072cb0a419081","883":"df091c1a9e96a8ada777"}[chunkId] + ".js";
};